import { useCallback, useEffect, useRef } from 'react';

export default function useIdleTimer(onIdle, timeout = 1000 * 60 * 59) {
  const timerId = useRef(null);
  // reseta o timer
  const reset = useCallback(() => {
    if (timerId.current) clearTimeout(timerId.current);
    timerId.current = setTimeout(onIdle, timeout);
  }, [onIdle, timeout]);

  useEffect(() => {
    // eventos
    const events = [
      'mousemove',
      'mousedown',
      'keydown',
      'touchstart',
      'scroll',
    ];
    // ao disparar qualquer evento reseta o timer
    events.forEach((evt) => window.addEventListener(evt, reset));
    // inicia a contagem validar
    reset();
    return () => {
      // limpa a contagem
      if (timerId.current) clearTimeout(timerId.current);
      events.forEach((evt) => window.removeEventListener(evt, reset));
    };
  }, [onIdle, timeout, reset]);
  return null;
}
